import { render, staticRenderFns } from "./DailyMilkRecording.vue?vue&type=template&id=6cf6a2f5&scoped=true&"
import script from "./DailyMilkRecording.vue?vue&type=script&lang=js&"
export * from "./DailyMilkRecording.vue?vue&type=script&lang=js&"
import style0 from "./DailyMilkRecording.vue?vue&type=style&index=0&id=6cf6a2f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf6a2f5",
  null
  
)

export default component.exports